/* Kurze Rückmeldung nach einer Aktion (z. B. "Player deleted").
 *
 * Zustand im Modulbereich; die Anzeige hängt einmal in App.vue (AppSnackbar.vue, Vuetify v-snackbar).
 * Texte kommen bereits übersetzt herein — hier steht keine Sprache. Ersetzt nach und nach die
 * alert()-Aufrufe (siehe CLAUDE.md, "Error Handling").
 */

import { ref } from 'vue';

const state = ref({ open: false, text: '', kind: 'success', id: 0 });

export function useSnackbar() {
  /** @param {string} text  schon übersetzt
   *  @param {'success'|'warning'|'error'} [kind] */
  function show(text, kind = 'success') {
    state.value = { open: true, text, kind, id: state.value.id + 1 };
  }
  function hide() {
    state.value = { ...state.value, open: false };
  }
  return { state, show, hide };
}
